"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InlineDrawer", {
    enumerable: true,
    get: function() {
        return InlineDrawer;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useInlineDrawer = require("./useInlineDrawer");
const _renderInlineDrawer = require("./renderInlineDrawer");
const _useInlineDrawerStylesstyles = require("./useInlineDrawerStyles.styles");
const InlineDrawer = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useInlineDrawer.useInlineDrawer_unstable)(props, ref);
    (0, _useInlineDrawerStylesstyles.useInlineDrawerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDrawerInlineStyles_unstable')(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useInlineDrawerStyles_unstable')(state);
    return (0, _renderInlineDrawer.renderInlineDrawer_unstable)(state);
});
InlineDrawer.displayName = 'InlineDrawer';
